export default "__VITE_ASSET__3f2e855f__"